module.exports = __webpack_public_path__ + "img/nav_icon_anesthesia.146d9bd8.svg";